import { Routes, Route } from 'react-router-dom'
import LandingPage from './pages/LandingPage'
import TravelAgentRegistrationPage from './pages/TravelAgentRegistrationPage'
import TravelAgentLoginPage from './pages/TravelAgentLoginPage'
import EmailVerificationPage from './pages/EmailVerificationPage'
import PasswordResetPage from './pages/PasswordResetPage'
import DashboardPage from './pages/DashboardPage'
import ProfileManagementPage from './pages/ProfileManagementPage'
import ReserveMembershipGuidePage from './pages/ReserveMembershipGuidePage'
import ReserveWelcomePackPage from './pages/ReserveWelcomePackPage'
import ReserveWelcomePackHandbookPage from './pages/ReserveWelcomePackHandbookPage'
import BankAccountPage from './pages/BankAccountPage'
import HotelSearchPage from './pages/HotelSearchPage'
import HotelDetailsPage from './pages/HotelDetailsPage'
import ProtectedRoute from './components/ProtectedRoute'
import TravelAdvisorRegisterPage from './pages/TravelAdvisorRegisterPage'
import ApplicationPendingPage from './pages/ApplicationPendingPage'
import ChangePasswordRequiredPage from './pages/ChangePasswordRequiredPage'
import OnboardingPage from './pages/OnboardingPage'
import ErrorBoundary from './components/ErrorBoundary'
import UserCartPage from './pages/UserCartPage'
import UserBookingPage from './pages/UserBookingPage'
import CommissionDetailsPage from './pages/commissionDetailsPage'
import ContactUsPage from './pages/ContactUsPage'
import ClientDetails from './pages/clientDetailsPage'
import ExperiencesPage from './pages/ExperiencesPage'
import ExperienceDetailsPage from './pages/ExperienceDetailsPage'
import ExperienceBillingPage from './pages/ExperienceBillingPage'
import AdamConciergePage from './pages/AdamConcierge/AdamConciergePage'
import PrivateJetPage from './pages/PrivateJetPage'
import OffMarketStaysPage from './pages/OffMarketStaysPage'
import OffMarketProtectedRoute from './components/OffMarketProtectedRoute'
import WhiteLabelingPage from './pages/WhiteLabelingPage'
import { Navigate } from 'react-router-dom'
import RedirectWithState from './components/RedirectWithState'
import LuxuryTravelAdvisorsPage from './pages/luxurytravel-advisors/LuxuryTravelAdvisorsPage'


function App() {
  return (
    <ErrorBoundary>
      <div className="min-h-screen min-w-0 w-full max-w-[100vw] overflow-x-clip bg-gray-50">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/luxurytravel-advisors" element={<LuxuryTravelAdvisorsPage />} />
          <Route path="/luxurytravel-advisors-register" element={<RedirectWithState to="/register" />} />
          <Route path="/luxurytravel-advisors-verification" element={<RedirectWithState to="/verify-email" />} />
          <Route path="/luxurytravel-advisors-status" element={<RedirectWithState to="/application-pending" />} />
          <Route path="/register" element={<TravelAdvisorRegisterPage />} />
          <Route path="/login" element={<TravelAgentLoginPage />} />
          <Route path="/verify-email" element={<EmailVerificationPage />} />
          <Route path="/application-pending" element={<ApplicationPendingPage />} />
          <Route
            path="/change-password-required"
            element={
              <ProtectedRoute>
                <ChangePasswordRequiredPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/onboarding"
            element={
              <ProtectedRoute>
                <OnboardingPage />
              </ProtectedRoute>
            }
          />
          <Route path="/reset-password" element={<PasswordResetPage />} />
          <Route path="/travel_agent_registration_completion/:userId" element={<TravelAgentRegistrationPage />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <ProfileManagementPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile/reserve-membership-guide/welcome-pack/:topicId"
            element={
              <ProtectedRoute>
                <ReserveWelcomePackHandbookPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile/reserve-membership-guide/welcome-pack"
            element={
              <ProtectedRoute>
                <ReserveWelcomePackPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile/reserve-membership-guide"
            element={
              <ProtectedRoute>
                <ReserveMembershipGuidePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bank-account"
            element={
              <ProtectedRoute>
                <BankAccountPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/hotels"
            element={
              <ProtectedRoute>
                <HotelSearchPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/hotel/:hotelCode"
            element={
              <ProtectedRoute>
                <HotelDetailsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cart"
            element={
              <ProtectedRoute>
                <UserCartPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user-bookings"
            element={
              <ProtectedRoute>
                <UserBookingPage />
              </ProtectedRoute>
            }
          />
          {/* Backwards compatibility: redirect old /my-booking path */}
          <Route
            path="/my-booking"
            element={<Navigate to="/user-bookings" replace />}
          />
          <Route
            path="/user-commission"
            element={
              <ProtectedRoute>
                <CommissionDetailsPage />
              </ProtectedRoute>
            }
          />
          {/* Old commission-markup page removed; send bookmarks to My Commissions */}
          <Route path="/commission-markup" element={<Navigate to="/user-commission" replace />} />
          <Route
            path="/clients"
            element={
              <ProtectedRoute>
                <ClientDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/experiences"
            element={
              <ProtectedRoute>
                <ExperiencesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/experiences/:countryId"
            element={
              <ProtectedRoute>
                <ExperiencesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/experience/:id"
            element={
              <ProtectedRoute>
                <ExperienceDetailsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cart/experience-billing"
            element={
              <ProtectedRoute>
                <ExperienceBillingPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ai-concierge"
            element={
              <ProtectedRoute>
                <AdamConciergePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/off-market-stays"
            element={
              <OffMarketProtectedRoute>
                <OffMarketStaysPage />
              </OffMarketProtectedRoute>
            }
          />
          <Route
            path="/private-jets"
            element={
              <ProtectedRoute>
                <PrivateJetPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/white-labeling"
            element={
              <ProtectedRoute>
                <WhiteLabelingPage />
              </ProtectedRoute>
            }
          />
          <Route path="/contact" element={<ContactUsPage />} />
        </Routes>
      </div>
    </ErrorBoundary>
  )
}

export default App
